import React, { Component } from 'react';
import Button from '../elements/Buttons';
import MapRender from './MapRender';

class PopupAlert extends Component{
    constructor(props){
        super(props);
        this.state = {
            mapRegion: null,
            lastLat: 24.176869443745133,
            lastLong: 46.068425139287385,
            currentLocation:this.props.geoPosition,
            currentLocationZoom:14,
            isLoaded:false,
            defaultLocation:this.props.geoPosition,
            defaultLocationZoom:this.props.geoPosition.lat===24.176869443745133? 5 : 14,
        }
    }
    // componentDidMount() {
    //     if ("geolocation" in navigator) {
    //         console.log("Available");
    //         navigator.geolocation.getCurrentPosition(
    //             function(position) {
    //               console.log(position);
    //             },
    //             function(error) {
    //               console.error("Error Code = " + error.code + " - " + error.message);
    //             }
    //         );
    //     } else {
    //         console.log("Not Available");
    //     }
    //     this.watchID = navigator.geolocation.watchPosition((position) => {
    //       // Create the object to update this.state.mapRegion through the onRegionChange function
    //       let region = {
    //         latitude:       position.coords.latitude,
    //         longitude:      position.coords.longitude,
    //         latitudeDelta:  0.00922*1.5,
    //         longitudeDelta: 0.00421*1.5
    //       }
    //       this.onRegionChange(region, region.latitude, region.longitude);
    //     });
    // }

    isLocationAllowed = () => {
        return new Promise((resolve) => {
          if (!navigator.geolocation) {
            // Geolocation is not supported by the browser
            resolve(false);
          } else {
            navigator.geolocation.getCurrentPosition(
              (position) => {
                // If position is successfully retrieved, location is allowed
                resolve(true);
              },
              (error) => {
                // If there is an error, check the error code
                if (error.code === error.PERMISSION_DENIED) {
                  // User denied the request for Geolocation
                  resolve(false);
                } else {
                  // Other errors (e.g., POSITION_UNAVAILABLE, TIMEOUT)
                  resolve(false);
                }
              },
            //   {
            //     enableHighAccuracy: true, // Request high-accuracy location data
            //     timeout: 10000,           // Set a timeout to avoid long waits
            //     maximumAge: 0             // Prevent using cached location data
            //   }
            );
          }
        });
    };

    componentDidMount(){
        this.isLocationAllowed().then((allowed) => {
            if (allowed) {
                this.watchID = navigator.geolocation.watchPosition((position) => {
                    // Create the object to update this.state.mapRegion through the onRegionChange function
                    let region = {
                    latitude:       position.coords.latitude,
                    longitude:      position.coords.longitude,
                    latitudeDelta:  0.00922*1.5,
                    longitudeDelta: 0.00421*1.5
                    }
                    this.onRegionChange(region, region.latitude, region.longitude);
                });
            } else {
                this.onRegionChange(region, this.state.lastLat, this.state.lastLong);
                // console.log('Location access is not allowed');
            }
        });
    }

    onRegionChange(region, lastLat, lastLong) {
        this.setState({
          mapRegion: region,
          // If there are no new values set use the the current ones
          lastLat: lastLat || this.state.lastLat,
          lastLong: lastLong || this.state.lastLong,
          currentLocation:{lat: lastLat, lng: lastLong },
        //   isLoaded:true
        });
    }
    
    componentWillUnmount() {
        navigator.geolocation.clearWatch(this.watchID);
    }
    
    render(){
        return(
            <div id="popup-alert">
                {/* {console.log(this.state.isLoaded)} */}
                <React.StrictMode>
                <div className="popup popup--centered popup--shadow popup--fullpage popup--feedback active">
                    {this.props.closeButtonShow && this.props.closeButtonShow==='true'?(
                        <div className="popup__close">
                            <Button
                                type="button"
                                classes='close-popup'
                                title='Close'
                                action={this.props.closeAction}
                                areaLabel='Close'
                                svg="true"
                                disabled=''
                            >
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 200 200">
                                    <g>
                                        <path fill="#294f96" d="M12.448,199.508c-3.343,0-6.626-1.276-9.179-3.769c-5.045-5.047-5.045-13.253,0-18.299L177.373,3.276
                                            c5.045-5.045,13.252-5.045,18.297,0c5.046,5.046,5.046,13.252,0,18.298L21.627,195.678
                                            C19.074,198.231,15.792,199.508,12.448,199.508z"/>
                                        <path fill="#294f96" d="M186.552,199.508c-3.344,0-6.626-1.276-9.179-3.769L3.33,21.635c-5.045-5.045-5.045-13.252,0-18.298
                                            c5.046-5.045,13.252-5.045,18.298,0L195.73,177.44c5.046,5.046,5.046,13.252,0,18.299
                                            C193.178,198.231,189.834,199.508,186.552,199.508z"/>
                                    </g>
                                </svg>
                            </Button>
                            
                        </div>
                    ):(null)}

                    {/* {this.state.isLoaded?(
                        <MapRender 
                            action={this.props.action}
                            language={this.props.language}
                            currentLocation={this.state.currentLocation}
                            defaultZoom={this.state.currentLocationZoom}
                        />
                    ):(
                        <MapRender 
                            action={this.props.action}
                            language={this.props.language}
                            currentLocation={this.state.defaultLocation}
                            defaultZoom={this.state.defaultLocationZoom}
                        />
                    )} */}
                    <MapRender 
                        action={this.props.action}
                        language={this.props.language}
                        currentLocation={this.state.currentLocation}
                        defaultZoom={this.props.geoPosition.lat===24.176869443745133? 5 : 14}
                    />
                    
                </div>
                </React.StrictMode>
            </div>
        )
    }
}
PopupAlert.propTypes = {
    closeAction: React.propTypes.node,
    action: React.propTypes.node,
    language: React.propTypes.node,
    closeButtonShow: React.propTypes.node,
}
export default PopupAlert;